"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Experiment = _interopRequireDefault(require("hublabs-core/Experiment"));

// makeExperiment
// ---
// The fact that hublabs uses classical inheritance to construct namespaces & experiments is an implementation detail.
// The goal of makeExperiment is to:
//  1. Abstract away classes as an implementation detail of hublabs.
//  2. Abstract away boilerplate to creating an experiment.
//  3. Add sane defaults to experiment options.
var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'GenericExperiment' : _ref$name,
      _ref$identifier = _ref.identifier,
      identifier = _ref$identifier === void 0 ? null : _ref$identifier,
      _ref$setupParams = _ref.setupParams,
      setupParams = _ref$setupParams === void 0 ? function () {} : _ref$setupParams,
      _ref$allowAutoExposur = _ref.allowAutoExposureLogging,
      allowAutoExposureLogging = _ref$allowAutoExposur === void 0 ? true : _ref$allowAutoExposur,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? 'v1' : _ref$version,
      _ref$useInNamespace = _ref.useInNamespace,
      useInNamespace = _ref$useInNamespace === void 0 ? true : _ref$useInNamespace,
      _ref$extraOpts = _ref.extraOpts,
      extraOpts = _ref$extraOpts === void 0 ? {} : _ref$extraOpts;

  var Experiment =
  /*#__PURE__*/
  function (_HublabsExperiment) {
    (0, _inherits2.default)(Experiment, _HublabsExperiment);

    function Experiment() {
      (0, _classCallCheck2.default)(this, Experiment);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Experiment).apply(this, arguments));
    }

    (0, _createClass2.default)(Experiment, [{
      key: "setup",
      value: function setup() {
        if (name) {
          this.setName(name);
        }

        this.version = version;
        this.setAutoExposureLogging(allowAutoExposureLogging);
      }
    }, {
      key: "assign",
      value: function assign(params) {
        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (setupParams && typeof setupParams === 'function') {
          var choose = this.choose.bind(this);
          var flipCoin = this.flipCoin.bind(this);
          setupParams(params, {
            choose: choose,
            flipCoin: flipCoin
          }, args);

          this.assign.toString = function () {
            return setupParams.toString();
          };
        }
      }
    }]);
    return Experiment;
  }(_Experiment.default);

  if (useInNamespace) {
    return Experiment;
  }

  if (identifier) {
    extraOpts.user_id = identifier;
  }

  return new Experiment(extraOpts);
};

exports.default = _default;
module.exports = exports.default;